import { routes } from "pages/routes";
import bookImg from "./../../../../../images/book.svg";
import { Link } from "react-router-dom";
import { FC } from "react";

interface IFolderCard {
  object: any;
}

const FolderCard: FC<IFolderCard> = props => {
  let image = null;
  if (props.object.preview_horizontal_url) {
    image = props.object.preview_horizontal_url;
  } else if (props.object.preview_url) {
    image = props.object.preview_url;
  } else {
    image = bookImg;
  }

  return (
    <div className="folder-card-wrapper">
      <Link to={routes.libraryObject.path({ id: props.object?.id })}>
        <div className="folder-card">
          <div className="img-container">
            <Link to={routes.libraryObject.path({ id: props.object?.id })}>
              <img src={image} alt="preview" className="preview-img" />
            </Link>
          </div>
          <div className="folder-card-title">{props.object.name}</div>
        </div>
      </Link>
    </div>
  );
};

export default FolderCard;
